function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled from 'styled-components';
import withSpacing from '../lib/hoc/withSpacing';
import { shade, themify } from '../styles/mixins';
const StyledTextLink = styled.span.withConfig({
  displayName: "TextLink__StyledTextLink",
  componentId: "i44dc4-0"
})(["display:", ";color:", ";cursor:pointer;transition:color 0.2s ", ";&:hover{color:", ";}"], x => x.$block ? 'block' : 'inline', x => x.$color, x => x.theme.curves.default, x => x.$hoverColor || shade(0.1, x.$color));

const TextLinkFunc = (_ref) => {
  let {
    block = false,
    children,
    color = 'inherit',
    hoverColor = 'green'
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["block", "children", "color", "hoverColor"]);

  return /*#__PURE__*/React.createElement(StyledTextLink, _extends({
    $block: block,
    $color: themify(color),
    $hoverColor: themify(hoverColor)
  }, rest), children);
};

export const TextLink = withSpacing(TextLinkFunc);